import React from 'react';
import PageLayout from '../../components/PageLayout/PageLayout';
import PageWidth from '../../components/Width/PageWidth';
import RegisterCard from '../Cards/RegisterCard/RegisterCard';

const HomePage = () => {
  return (
    <PageLayout
     bg="linear-gradient(90deg, #141E30 0%, #243B55 100%)"
     >
      <PageWidth>
        <RegisterCard />
      </PageWidth>
    </PageLayout>
  )
};

export default HomePage;
